import React, { useState } from 'react';
import Header from '../componentes/Header';
import { Link, useNavigate } from 'react-router';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import AnimacionPagina from '../componentes/AnimacionPagina';
import productosPriveCollection from '../data/todosLosProductos/productosPriveCollection';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import ModalImagenExpandida from '../componentes/ModalImagenExpandida';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaPriveCollection = () => {
    const navigate = useNavigate();
    const [imagenExpandida, setImagenExpandida] = useState(null);

    const [categoriaActiva, setCategoriaActiva] = useState('Dim out');
    const categorias = ['Dim out', 'Filtro Ligero', 'Blackout'];
    
    return ( 
        <>
        <Helmet>
          <title>Prive Collection | Hi Blinds</title>
          <meta name="description" content="Descubre la Prive Collection. Comportamiento lumínico, compatibilidad con el diseño interior y coherencia estética en Dim out, Filtro Ligero y Blackout." />
          <meta property="og:title" content="Prive Collection | Hi Blinds" />
          <meta property="og:description" content="Catálogo estructurado para proyectos de alto nivel. Modelos Dim out, Filtro Ligero y Blackout." />
          <meta property="og:url" content="https://hiblindsmx.com/prive-collection" />
        </Helmet>
        <Header />
        <AnimacionPagina>
            <SectionProductos>
                <h1>Prive Collection</h1>
                <BtnVolverAnim Ref="/" />
                <ContenedorPrive>
                  {categorias.map((categoria) => (
                    <motion.div
                        key={categoria}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        <BotonCategoria
                          activo={categoriaActiva === categoria}
                          onClick={() => setCategoriaActiva(categoria)}
                        >
                          {categoria}
                        </BotonCategoria>
                    </motion.div>
                  ))}
                </ContenedorPrive>
                <ContainerProductos>
                    {productosPriveCollection
                    .filter(p => p.categoria === categoriaActiva)
                    .map((producto, index) =>  {
                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer
                              whileHover={{ scale: 1.05 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={() => {
                                navigate(`/prive-collection/${producto.categoriaSlug}/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                             <motion.img
                                loading='lazy' 
                                src={producto.images[0]} 
                                alt={`${producto.nombre}`}
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.9 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setImagenExpandida(producto.images[0]);
                                }}
                              />
                             <h4>{producto.nombre}</h4>
                             <p>Ancho de tela:
                              <br/>{producto.anchoTela} m
                             </p>
                             <Link to={`/prive-collection/${producto.categoriaSlug}/${producto.slug}`}>
                                <button type='button'>Más información</button>
                             </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                    })}
                </ContainerProductos>
                <BtnVolverAnim Ref="/" />
            </SectionProductos>
            <Footer />
        </AnimacionPagina>
        <ModalImagenExpandida
                imagen={imagenExpandida}
                onClose={() => setImagenExpandida(null)}
              />
        </>
     );
}

const ContenedorPrive = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 15px 10px;
    justify-content: center;
    margin-top: 10px;
`
const BotonCategoria = styled.button`
  background-color: ${({ activo }) => (activo ? ' #959cfa' : '#010755')};
  color: #fff;
  padding: 12px 12px;
  min-width: 165px;
  max-width: 165px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: transform .3s, background .5s;
`;

export default PaginaPriveCollection;